import { render, staticRenderFns } from "./BriefingView.vue?vue&type=template&id=dcb75ef0"
import script from "./BriefingView.vue?vue&type=script&lang=js"
export * from "./BriefingView.vue?vue&type=script&lang=js"
import style0 from "./BriefingView.vue?vue&type=style&index=0&id=dcb75ef0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports